import type { SetupPaymentMethodResponse } from '../../../services/customer/types';

export function assertValidSetupPaymentMethodResponse(
  createPaymentMethodResponse: unknown,
): asserts createPaymentMethodResponse is SetupPaymentMethodResponse {
  if (
    !createPaymentMethodResponse ||
    (typeof createPaymentMethodResponse === 'object' &&
      'errors' in createPaymentMethodResponse &&
      Array.isArray(createPaymentMethodResponse.errors) &&
      createPaymentMethodResponse.errors.length)
  ) {
    throw new Error('Failed to add payment method');
  }
}
